module.exports = __webpack_public_path__ + "img/BlinkArt_Sword1_Silver.0447b669.png";